import { render, staticRenderFns } from "./TicketSlaColumn.vue?vue&type=template&id=64e04310&scoped=true"
import script from "./TicketSlaColumn.vue?vue&type=script&lang=js"
export * from "./TicketSlaColumn.vue?vue&type=script&lang=js"
import style0 from "./TicketSlaColumn.vue?vue&type=style&index=0&id=64e04310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e04310",
  null
  
)

export default component.exports